import React, { useState, useRef } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import emailjs from '@emailjs/browser';

const ContactForm = (props) => {

    const form = useRef();
    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: 'SaasWatch Marketing Site Message',
        phone: '',
        company: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            emailjs.sendForm('service_7pfsmth', 'template_q3gnd5m', form.current, {
                publicKey: 'qiMjhulEC6Bo-RH9o',
                }).then(
                () => {
                    // console.log('SUCCESS!');
                },
                (error) => {
                    // console.log('FAILED...', error);
                },
                );

            validator.hideMessages();
            setForms({
                name: '',
                email: '',
                subject: 'SaaSWatch Marketing Site Message',
                phone: '',
                company: '',
                message: ''
            })
        } else {
            validator.showMessages();
        }
    };

    const inputStyle = {
        width: '100%',
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        borderRadius: '12px',
        color: 'white',
        padding: '16px 20px',
        fontSize: '16px',
        transition: 'all 0.3s ease',
        marginBottom: '20px'
    };

    const labelStyle = {
        display: 'block',
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '14px',
        fontWeight: '500',
        marginBottom: '8px'
    };

    return (
        <form ref={form} onSubmit={(e) => submitHandler(e)} className="contact-form">
            <div className="row">
                <input type="hidden" name="subject" value="SaasWatch Marketing Site Message" />
                <div className="col-lg-6">
                    <div className="input-field">
                        <label style={labelStyle} htmlFor="name">Name*</label>
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            id="name"
                            style={inputStyle}
                            placeholder="Your name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                        />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="input-field">
                        <label style={labelStyle} htmlFor="email">Email*</label>
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            id="email"
                            style={inputStyle}
                            placeholder="your@email.com"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                        />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field">
                        <label style={labelStyle} htmlFor="phone">Phone*</label>
                        <input
                            value={forms.phone}
                            type="phone"
                            name="phone"
                            id="phone"
                            style={inputStyle}
                            placeholder="Your phone number"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                        />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field text-field">
                        <label style={labelStyle} htmlFor="message">Message</label>
                        <textarea
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.message}
                            name="message"
                            id="message"
                            style={{
                                ...inputStyle,
                                minHeight: '120px',
                                resize: 'vertical'
                            }}
                            placeholder="How can we help you?"
                        />
                        {validator.message('message', forms.message, 'required')}
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '10px' }}>
                <button
                    type='submit'
                    className="btn-gradient"
                    style={{
                        width: '100%',
                        padding: '18px 32px',
                        fontSize: '16px'
                    }}
                >
                    Send Message
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '10px' }}>
                        <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </form>
    )
}

export default ContactForm;
